import { zodResolver } from "@hookform/resolvers/zod";
import React, { FC } from "react";
import { useForm, FormProvider } from "react-hook-form";

interface Props {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues?: any;
}

const ControlledForm: FC<Props> = ({ children, schema, defaultValues }) => {
  const methods = useForm({
    defaultValues,
    resolver: zodResolver(schema),
    mode: "onChange",
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export default ControlledForm;
